import RefundTransactionDetails from "./refund-transaction-details.view";

export default RefundTransactionDetails;
